export default function Reassurances() {
  const items = [
    { icon: "ri-time-line", label: "Intervention 24h" },
    { icon: "ri-file-list-3-line", label: "Devis gratuit" },
    { icon: "ri-shield-check-line", label: "Toutes marques" },
    { icon: "ri-award-line", label: "Garantie 10 ans" },
  ];

  return (
    <section className="bg-white border-b border-brand-border py-6 md:py-8">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {items.map((item, i) => (
            <div key={i} className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-cyan/10 text-brand-cyan shrink-0">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <span className="text-sm font-medium text-brand-blue whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}